import { Actions } from '../actions/qualificationProviders';
import { AxiosError } from 'axios';
import { DeepReadonly } from 'utility-types';
import { IQualificationProvider } from '../interfaces/qualificationProvider';

export type State = DeepReadonly<{
  isFetching: boolean;
  qualificationProviders: IQualificationProvider[] | null;
  error: AxiosError | null;
}>;

const initialState: State = {
  isFetching: false,
  qualificationProviders: null,
  error: null
};

export function reducer(state: State = initialState, action: Actions): State {
  switch (action.type) {
    case 'FETCH_QUALIFICATION_PROVIDERS_REQUEST':
      return {
        ...state,
        isFetching: true
      };
    case 'FETCH_QUALIFICATION_PROVIDERS_SUCCESS':
      return {
        isFetching: false,
        qualificationProviders: action.payload,
        error: null
      };
    case 'FETCH_QUALIFICATION_PROVIDERS_FAILURE':
      return {
        ...state,
        isFetching: false,
        error: action.error
      };
    default:
      return state;
  }
}
